import React, { FC } from "react";

export interface CompletionItem {
  id: string;
  title: string;
  caption: string;
}

export interface CompletionListProps {
  items: CompletionItem[];
  className?: string;
}

/**
 * The bordered checklist the two result screens use to recap what has been
 * collected. Left-aligned inside an otherwise centred screen.
 */
const CompletionList: FC<CompletionListProps> = ({ items, className = "" }) => (
  <div
    className={`mx-auto max-w-[560px] border border-line text-left ${className}`}
  >
    {items.map((item, i) => (
      <div
        key={item.id}
        className={`flex items-center gap-[13px] px-4 py-[13px] ${
          i > 0 ? "border-t border-line" : ""
        }`}
      >
        <span
          className="flex h-[25px] w-[25px] flex-none items-center justify-center rounded-full bg-[#e7efe9] text-[13px] text-[#52705b]"
          aria-hidden="true"
        >
          ✓
        </span>

        <p className="m-0">
          <strong className="block text-[15px] font-semibold text-navy">
            {item.title}
          </strong>
          <small className="block text-[13px] min-[760px]:text-[13px] text-[#95999d]">
            {item.caption}
          </small>
        </p>
      </div>
    ))}
  </div>
);

export default CompletionList;
